import { useHasPaymentIncident } from '@weenat/client/dist/core/billing'
import { BillingStatus } from '@weenat/client/dist/enums'
import { useOrgContext } from 'app/orgProvider'
import { useToken } from 'app/state'
import isNil from 'lodash-es/isNil'
import { useMemo } from 'react'

export type RestrictionReason = 'downgrade' | 'freemium'

/**
 *
 * check if access shouldbe restricted based on unpaid bills + feature flag
 * this hook should be deleted and replace by useHasPaymentIncident on flag deletion
 */
export const useIsAppAccessRestricted = (props?: { isVWS?: boolean }) => {
  const org = useOrgContext()
  const [token] = useToken()

  const isVWS = props?.isVWS

  const { hasPaymentIncident, paymentIncidentRequest } = useHasPaymentIncident({
    enabled: !isNil(token),
    orgId: org.id
  })

  const reason: RestrictionReason = hasPaymentIncident
    ? ('downgrade' as const)
    : ('freemium' as const)
  const billingStatus = org?.billingStatus
  return useMemo(() => {
    return isNil(isVWS)
      ? {
          isRestricted: billingStatus === BillingStatus.essential,
          reason: reason,
          isLoading: paymentIncidentRequest.isLoading
        }
      : {
          isRestricted: isVWS
            ? hasPaymentIncident && billingStatus === BillingStatus.essential
            : billingStatus === BillingStatus.essential,
          reason: reason,
          isLoading: paymentIncidentRequest.isLoading
        }
  }, [isVWS, billingStatus, reason, paymentIncidentRequest.isLoading, hasPaymentIncident])
}
